import React from 'react';
import PropTypes from 'prop-types';
import { Field, useFormikContext } from 'formik';
import SelectInput from './SelectInput';

const MultiSelectField = ({
  creatable,
  exclusiveValue,
  isLoading,
  label,
  max,
  name,
  onChange,
  options,
  placeholder,
}) => {
  const { values, setFieldValue } = useFormikContext();
  const currentValues = values[name] || [];

  const handleChange = (selectedValues = []) => {
    const normalizedValues = Array.isArray(selectedValues)
      ? selectedValues
      : [];
    let nextValues = normalizedValues;

    if (exclusiveValue) {
      const previouslyExclusive = currentValues.some(
        ({ value }) => value === exclusiveValue
      );
      const includesExclusive = normalizedValues.some(
        ({ value }) => value === exclusiveValue
      );

      if (includesExclusive && !previouslyExclusive) {
        nextValues = normalizedValues.filter(
          ({ value }) => value === exclusiveValue
        );
      } else if (previouslyExclusive && normalizedValues.length > 1) {
        nextValues = normalizedValues.filter(
          ({ value }) => value !== exclusiveValue
        );
      }

      if (nextValues !== normalizedValues) setFieldValue(name, nextValues);
    }

    onChange(nextValues);
  };

  return (
    <div className="mb-5">
      {label && <p className="text-dusty text-xs mb-2">{label}</p>}
      <Field
        name={name}
        component={SelectInput}
        isMulti
        creatable={creatable}
        isLoading={isLoading}
        options={options}
        placeholder={placeholder}
        onChange={handleChange}
        isOptionDisabled={() => max && currentValues.length >= max}
      />
    </div>
  );
};

MultiSelectField.propTypes = {
  creatable: PropTypes.bool,
  exclusiveValue: PropTypes.string,
  isLoading: PropTypes.bool,
  label: PropTypes.string,
  max: PropTypes.number,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.string.isRequired,
};

MultiSelectField.defaultProps = {
  creatable: true,
  exclusiveValue: null,
  isLoading: false,
  label: null,
  max: null,
  onChange: () => {},
  options: [],
};

export default MultiSelectField;
